import { ChartOptions, ChartType, Color, Plugin } from 'chart.js';
import '@lacour/chartjs-chart-geo';
import '@lacour/chartjs-chart-pathflow';
import { StatsGraphDataRecords, StatsGraphShape } from '../tools/api.service';
import { ColorKind } from '../tools/utils';

export interface ChartDataset<TData> {
  indexAxis?: 'x' | 'y';
  label: string;
  key: string
  order?: number;
  stack?: string;
  hidden?: boolean;

  data: TData;

  borderWidth?: number;
  borderColor?: string | string[] | Color;
}

export interface ChartData<
  TData = any,
  TLabel = unknown  
  > {
  labels?: TLabel[];
  tableLabels?: TLabel[];
  datasets: ChartDataset<TData>[];
}

export interface ChartSpecific<
  TType extends ChartType = ChartType>
{
  type: TType;
  options?: ChartOptions<TType>;
  plugins?: Plugin<TType>[];
}

export interface ChartConfig {
  data: ChartData;
  colorKind?: ColorKind;
  xName?: string;
  yName?: string;
  keyName?: string;
  labelName?: string;
  actions: { date: string, user: string, label: string }[];
  arbTbl: any[];
  arbNames: { [key: string]: string };
  arbSort: boolean;
  shapeOverride: StatsGraphShape | null;
  specific?: ChartSpecific[];
}

export class ChartContent {
  config: ChartConfig;

  constructor(config: ChartConfig) {
    this.config = config;
  }
}
